import {
  Command,
  CommandDialog,
  CommandHeader,
  CommandInput,
  CommandList,
} from "@hortis/ui/command";
import type {
  MapMaterialListFieldsFragment,
  MaterialsListFieldsFragment,
} from "generated/graphql";
import { useState } from "react";
import { CommandMenuStatusPage } from "src/components/command-menu/command-menu-pages/status";
import { MakeAbsentDialog } from "src/features/create-accession/components/accession-data-form/make-absent-dialog";

interface StatusDialogProps {
  selectedRows: Array<
    MaterialsListFieldsFragment | MapMaterialListFieldsFragment
  >;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  handleSuccess: () => void;
}

const StatusDialog = ({
  title,
  selectedRows,
  open,
  onOpenChange,
  handleSuccess,
}: StatusDialogProps) => {
  const [absentDialogOpen, setAbsentDialogOpen] = useState(false);

  return (
    <>
      <CommandDialog open={open} onOpenChange={onOpenChange}>
        <Command data-cy="context-menu-status-dialog" size="lg">
          <CommandHeader title={title} />
          <CommandInput
            placeholder="Change status..."
            data-cy="context-menu-search-filter"
          />
          <CommandList>
            <CommandMenuStatusPage
              onAbsentSelect={() => {
                setAbsentDialogOpen(true);
                onOpenChange(false);
              }}
              onSuccess={handleSuccess}
              selectedMaterials={selectedRows}
            />
          </CommandList>
        </Command>
      </CommandDialog>
      <MakeAbsentDialog
        open={absentDialogOpen}
        onOpenChange={setAbsentDialogOpen}
        onSuccess={handleSuccess}
        selectedMaterials={selectedRows}
      />
    </>
  );
};

export { StatusDialog };
